<template>
  <div
    class="fx-page-detail"
    :class="{
      'has-required': hasRequired,
      'readonly': readonly,
      'multiple': multiple
    }"
    :style="[
      !hasAffix ? '--affix-height: 0px' : '',
      !multiple && hasMap ? 'height: calc(100% - var(--affix-height))' : '',
      multiple && hasMap ? 'max-height: calc(100% - var(--affix-height))' : '',
      !multiple && !hasMap ? 'min-height: calc(100% - var(--affix-height))' : '',
    ]"
  >
    <div class="header">
      <div class="title"><span class="line"></span><span class="txt">{{ title }}</span></div>
      <slot name="action"></slot>
    </div>
    <div class="content" :class="{ 'has-map': hasMap }">
      <slot name="content">
        <template v-if="hasMap">
          <hl-form ref="formRef" :width="['col-24', 'col-24']" class="left-form" v-bind="formProps">
            <hl-group dir="vertical" gap-y="var(--lg)" class="form-scrollbar">
              <slot></slot>
            </hl-group>
          </hl-form>
          <div class="right-map" :class="multiple && hasMap ? 'max-h-full' : 'h-full'">
            <slot name="map"></slot>
          </div>
        </template>
        <template v-else>
          <hl-form
            ref="formRef"
            :width="['col-24', 'col-24']"
            class="hl-row grid grid-direction-vertical count-3 page-form"
            v-bind="formProps"
          >
            <slot></slot>
          </hl-form>
        </template>
      </slot>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue'
import { HlForm, HlGroup } from 'hongluan-ui'

export default defineComponent({
  name: 'PageDetail',
  components: { HlForm, HlGroup },
  props: {
    title: String,
    hasMap: Boolean,
    hasAffix: {
      type: Boolean,
      default: true,
    },
    multiple: Boolean,
    hasRequired: Boolean,
    readonly: Boolean,
    formProps: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    const formRef = ref()
    return {
      formRef,
    }
  },
})
</script>
